export function formatFechaYYYYMMDD(fecha) {
  if (!fecha) return "";
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(fecha);
  if (!m) return fecha;

  const y = Number(m[1]);
  const mo = Number(m[2]) - 1;
  const d = Number(m[3]);

  // Avoid timezone shifting by constructing with y/mo/d
  const dt = new Date(y, mo, d);

  return dt.toLocaleDateString("es-MX", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

export function formatFechaRange({ fechaInicio, fechaFin } = {}) {
  if (!fechaInicio && !fechaFin) return "Sin fecha";
  if (fechaInicio && fechaFin && fechaFin !== fechaInicio) {
    const re = /^(\d{4})-(\d{2})-(\d{2})$/;
    const a = re.exec(fechaInicio);
    const b = re.exec(fechaFin);

    if (a && b) {
      const y1 = Number(a[1]);
      const m1 = Number(a[2]);
      const d1 = Number(a[3]);
      const y2 = Number(b[1]);
      const m2 = Number(b[2]);
      const d2 = Number(b[3]);

      const meses = [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre",
      ];

      if (y1 === y2 && m1 === m2) {
        return `${d1} al ${d2} de ${meses[m1 - 1]}, ${y1}`;
      }

      if (y1 === y2) {
        return `${d1} de ${meses[m1 - 1]} al ${d2} de ${meses[m2 - 1]}, ${y1}`;
      }
    }

    return `${formatFechaYYYYMMDD(fechaInicio)} - ${formatFechaYYYYMMDD(fechaFin)}`;
  }
  return formatFechaYYYYMMDD(fechaInicio || fechaFin);
}


export function formatHoraHHMM(hhmm) {
  if (!hhmm) return "â€”";
  const m = /^(\d{2}):(\d{2})$/.exec(hhmm);
  if (!m) return hhmm;

  let h = Number(m[1]);
  const min = m[2];

  const ampm = h >= 12 ? "P.M." : "A.M.";
  h = h % 12;
  if (h === 0) h = 12;

  return `${h}:${min} ${ampm}`;
}

export function toNullIfEmpty(value) {
  const v = (value ?? "").trim();
  return v ? v : null;
}
